<img src="assets/images/EY-Logo-White.png" class="loader-landing-ey-logo">
<img src="assets/images/IRR-Logo3.svg" class="loader-landing-irr-logo">
<div class="container h-100vh d-flex flex-column align-items-center justify-content-center">
    <div class="row mx-0 mb-5">
        <div class="col-12 text-center">
                <h1 class="loading-app-name my-lg-5 my-xl-5"> <b>I</b>ntegrated <b>R</b>egulatory <b>R</b>eporting</h1>
                <img src="assets/images/IRR-Landing-Graphic-New.svg" class="landing-img-loader animated fadeIn infinite slower" />
        </div>
    </div>
</div>